module.exports = __webpack_public_path__ + "img/plus_btn.2ebe1eb0.png";